import { useMemo, useState } from 'react';

const useBooleanState = (initialValue: boolean) => {
  const [isTrue, setIsTrue] = useState(initialValue);

  const actions = useMemo(
    () => [() => setIsTrue(true), () => setIsTrue(false), () => setIsTrue((prev) => !prev)] as const,
    [],
  );

  return [isTrue, ...actions, setIsTrue] as const;
};

export default useBooleanState;
